import React from 'react';

export function NotificationIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 20 21"
      {...props}
    >
      <path d="M10 18.968c.917 0 1.667-.75 1.667-1.667H8.333c0 .917.742 1.667 1.667 1.667zm5-5V9.8c0-2.559-1.367-4.7-3.75-5.267v-.567c0-.691-.558-1.25-1.25-1.25s-1.25.559-1.25 1.25v.567C6.358 5.101 5 7.234 5 9.801v4.166l-1.667 1.667v.834h13.334v-.834L15 13.967z" />
    </svg>
  );
}
